import React, { useEffect } from "react";
import JoinUs from "./../../components/Common/JoinUs/JoinUs";
import ProductsBanner from "./ProductsBanner/ProductsBanner";
import Products from "./ProductsList/ProductsList";
import OurProduct from "./OurProducts/OurProduct";
//import Recommended from "./Recommended/Recommended";

const Index = () => {
  useEffect(() => {
    document.body.classList.add("remove-body-padding");
    document.getElementById("header").classList.add("header-bg-blue");
    return () => {
      document.body.classList.remove("remove-body-padding");
      document.getElementById("header").classList.remove("header-bg-blue");
    };
  }, []);
  const hostname = window.location.hostname;
  return (
    <>
      <ProductsBanner />
      {hostname === "www.novotrack.co.uk" ? <OurProduct /> : "" }
      <Products />
      {/* {hostname === "www.novotrack.co.uk" ? <Recommended /> : "" } */}
      <JoinUs />
    </>
  );
};

export default Index;
